import styles from "./styles.module.scss";
import primaryComponents from "../../../../primaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import {
  setToDateMonthYearInWordsByOnLocal,
  toAmPm,
} from "../../../../../helpers";
import EditIconV2 from "../../../../../assets/svgIcons/EditIconV2";
import { useCart } from "../../../../../hooks/useCart";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useTimeView } from "../TimeView/useTimeView";
import { DeleteBtnIcon } from "../../../../../assets/svgIcons";

export const BookingSummary = ({
  serviceDetails = {},
  bookDetails = {},
  setBookDetails = () => {},
}) => {
  const { handleAddToCart } = useCart({});
  const navigate = useNavigate(-1);

  const { removeSlot, updateSlotCount } = useTimeView({
    bookDetails,
    setBookDetails,
  });

  const totalBookedSlots = useMemo(() => {
    return (
      bookDetails?.bookings?.reduce((total, booking) => {
        return (
          total +
          (booking.time_slots?.reduce(
            (sum, slot) => sum + (slot.no_of_slot || 0),
            0,
          ) || 0)
        );
      }, 0) || 0
    );
  }, [bookDetails?.bookings]);

  return (
    <section className={`${styles.bookingSummary}`}>
      <h5>Bookings Summary</h5>

      <div className={styles.bookings}>
        {bookDetails?.bookings?.map((booking, index) => {
          return (
            <div key={index} className={styles.bookings__card}>
              <div className="d-flex justify-content-between">
                <h6 className="mb-0">
                  {setToDateMonthYearInWordsByOnLocal(booking?.date)}
                </h6>

                <span
                  className="cursor-pointer purple--text d-flex align-items-center"
                  onClick={() =>
                    setBookDetails((prev) => ({
                      ...prev,
                      active_booking_date: booking?.date,
                    }))
                  }
                >
                  <span className="mr-2">Update</span> <EditIconV2 />
                </span>
              </div>
              <hr />

              {booking?.time_slots?.map((time_slot, index) => {
                const actualTimeSlot = {
                  ...time_slot,
                  start_time: time_slot?.time,
                };

                return (
                  <div
                    key={index}
                    className="d-flex flex-wrap justify-content-between align-items-center mb-2"
                    style={{ gap: "25px" }}
                  >
                    <p>{toAmPm(time_slot?.time)}</p>
                    <div className="d-flex" style={{ gap: 10 }}>
                      <primaryComponents.Button
                        classNames="btn btn--outline"
                        style={{ height: 40, width: 70 }}
                        onClick={() =>
                          updateSlotCount(-1, actualTimeSlot, booking?.date)
                        }
                      >
                        -
                      </primaryComponents.Button>

                      <primaryComponents.CartInputField
                        defaultValue={time_slot.no_of_slot}
                        style={{ height: 40, width: 70 }}
                        updateCart={(val) =>
                          updateSlotCount(val, actualTimeSlot, booking?.date)
                        }
                      />

                      <primaryComponents.Button
                        className="btn btn--primary"
                        style={{ height: 40, width: 70 }}
                        onClick={() =>
                          updateSlotCount(1, actualTimeSlot, booking?.date)
                        }
                      >
                        +
                      </primaryComponents.Button>

                      <primaryComponents.Button
                        className="btn btn--outline-red"
                        style={{ height: 40, width: 45, padding: 0 }}
                        onClick={() =>
                          removeSlot(actualTimeSlot, booking?.date)
                        }
                      >
                        <DeleteBtnIcon />
                      </primaryComponents.Button>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>

      <div className={`${globalStyles.cardWithBorder} white mt-auto`}>
        <p>
          Total No Slots:{" "}
          <span className="purple--text">{totalBookedSlots}</span>
        </p>
      </div>

      <div
        className={`${globalStyles.stickyBottomCover} ${styles.bookingSummary__bottom}`}
      >
        <primaryComponents.Button
          classNames="btn btn--primary cover"
          onClick={() => {
            handleAddToCart({
              quantity: totalBookedSlots,
              product: serviceDetails,
              bookings: bookDetails?.bookings,
            });
            navigate(-1);
          }}
        >
          Confirm Reservation
        </primaryComponents.Button>
      </div>
    </section>
  );
};
